import styled from "styled-components";
export const SimpleTextAreaStyle = styled.div`
  width: 100% !important;

  textarea {
    width: 100% !important;
    resize: none;
    color: ${({ theme }) => theme.text};

    background-color: ${({ theme }) => theme.body} !important;
    &:focus {
      box-shadow: none;
      color: ${({ theme }) => theme.text};
    }
    ::placeholder {
      font-size: 12px;
      color: #6c757d;
    }
  }
`;
